// extracted by mini-css-extract-plugin
export default {"fields":"ML8SJh","time":"ubPNZH","mobile":"t4jWZo"};